import { parseISO, format, isValid } from "date-fns";

export default class DateTimeHelper {

  public static GetTodayDay():number{
    return (new Date()).getDate()
  }

  private static toValidDate(date: Date | string | undefined): Date | null {
    if (!date) {
      return null;
    }

    if (date instanceof Date) {
      return isValid(date) ? date : null;
    }

    const value = String(date).trim();
    if (!value) {
      return null;
    }

    const normalized = value.replace(/(\.\d{3})\d+(Z|[+-]\d{2}:?\d{2})$/, '$1$2');
    const parsedIso = parseISO(normalized);
    if (isValid(parsedIso)) {
      return parsedIso;
    }

    const parsedDate = new Date(value);
    return isValid(parsedDate) ? parsedDate : null;
  }

  public static ToDdMmmYyyy(date: Date | string | undefined): string {
    const parsed = DateTimeHelper.toValidDate(date);
    if (!parsed) {
      return "";
    }
    return format(parsed, "dd-MMM-yyyy");
  }
  public static ToMmmmYyyy(date: Date | string | undefined): string {
    const parsed = DateTimeHelper.toValidDate(date);
    if (!parsed) {
      return "";
    }
    return format(parsed, "MMMM yyyy");
  }
  public static ToMonthNameMmmm(date: Date | string | undefined): string {
    const parsed = DateTimeHelper.toValidDate(date);
    if (!parsed) {
      return "";
    }
    return format(parsed, "MMMM");
  }

  public static ToDdMmmYyyyHhMmssAmPm(date: Date | string | undefined): string {
    const parsed = DateTimeHelper.toValidDate(date);
    if (!parsed) {
      return "";
    }
    return format(parsed, "dd-MMM-yyyy h:mm:ss a");
  }

  /**
   * Formats a UTC instant as Indian Standard Time (Asia/Kolkata).
   * Strings without a timezone offset are treated as UTC (ApiCallLog TimestampUtc).
   */
  public static ToIstDdMmmYyyyHhMmssAmPm(date: Date | string | undefined): string {
    const instant = DateTimeHelper.toUtcInstant(date);
    if (!instant) {
      return "";
    }

    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).formatToParts(instant);

    const get = (type: string) => parts.find((p) => p.type === type)?.value || "";
    const day = get("day");
    const month = get("month");
    const year = get("year");
    const hour = get("hour");
    const minute = get("minute");
    const second = get("second");
    const dayPeriod = (get("dayPeriod") || "").toUpperCase();
    return `${day}-${month}-${year} ${hour}:${minute}:${second} ${dayPeriod}`;
  }

  private static toUtcInstant(date: Date | string | undefined): Date | null {
    if (!date) {
      return null;
    }

    if (date instanceof Date) {
      return isValid(date) ? date : null;
    }

    const value = String(date).trim();
    if (!value) {
      return null;
    }

    const hasOffset = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);
    const normalized = value
      .replace(/(\.\d{3})\d+(Z|[+-]\d{2}:?\d{2})$/, "$1$2")
      .replace(/(\.\d{3})\d+$/, "$1");
    const asUtc = hasOffset ? normalized : (normalized.endsWith("Z") ? normalized : `${normalized}Z`);
    const parsedIso = parseISO(asUtc);
    if (isValid(parsedIso)) {
      return parsedIso;
    }

    const parsedDate = new Date(asUtc);
    return isValid(parsedDate) ? parsedDate : null;
  }
  public static InputDateFormater(date: Date | undefined) {
    if (!date) {
      return;
    }
    return new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000);
  }
  public static ParseISO(date: Date | string | undefined): Date | null {
    const parsed = DateTimeHelper.toValidDate(date);
    return parsed;
  }
}
